// A mock function to mimic making an async request for data
export function fetchPlanPrice() {
  return new Promise(async (resolve) => {
    const response = await fetch("/planPrice");
    const data = await response.json();
    resolve({ data });
  });
}

export function fetchPlanPriceById(id) {
  return new Promise(async (resolve) => {
    const response = await fetch("/planPrice/" + id);
    const data = await response.json();
    resolve({ data });
  });
}
